module.exports = __webpack_public_path__ + "img/ftm-forestGreen.29a214f7.png";